import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { Check, Gift, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const bonuses = [{
    title: 'BONUS #1: Protocolo Anti-Hinchazón de OFICINA',
    value: '$19.97',
    desc: "Plan de comidas exacto para 'resetear' tu digestión."
  }, {
    title: 'BONUS #2: Checklist de Emergencia',
    value: '$14.97',
    desc: '¿Tienes una fiesta en 2 horas y estás hinchada? Usa esto.'
  }];
  return <Section id="offer" background="coral-light" className="overflow-hidden" data-id="element-132">
      <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-133">
        <div className="grid lg:grid-cols-2" data-id="element-134">
          {/* Left Side: Product Visual & Value Stack */}
          <div className="p-8 md:p-12 bg-[#F0FDFA] flex flex-col justify-center" data-id="element-135">
            <div className="relative mx-auto mb-8 w-3/4" data-id="element-136">
              <div className="absolute inset-0 bg-[#14B8A6] blur-3xl opacity-30 rounded-full" data-id="element-137"></div>
              <img src="https://cdn.magicpatterns.com/uploads/hZhPEEpQETkzDV2iTWL4vN/d135fca7-e6f3-4c98-aa3d-923f61a52d3b.jpg" alt="Guía Completa" className="relative z-10 w-full drop-shadow-xl transform rotate-[-5deg] hover:rotate-0 transition-transform duration-500" data-id="element-138" />
            </div>

            <div className="space-y-3" data-id="element-139">
              <div className="flex justify-between items-center text-sm text-[#5D5D5D] border-b border-[#5EEAD4]/20 pb-2" data-id="element-140">
                <span data-id="element-141">La Guía Anti-Hinchazón</span>
                <span className="line-through" data-id="element-142">$47.00</span>
              </div>
              {bonuses.map((b, i) => <div key={i} className="flex justify-between items-center text-sm text-[#5D5D5D] border-b border-[#5EEAD4]/20 pb-2" data-id="element-143">
                  <span className="flex items-center" data-id="element-144">
                    <Gift size={14} className="mr-2 text-[#14B8A6]" data-id="element-145" /> {b.title}
                  </span>
                  <span className="line-through" data-id="element-146">{b.value}</span>
                </div>)}
              <div className="flex justify-between items-center font-bold text-[#4A3B32] pt-2 text-lg" data-id="element-147">
                <span data-id="element-148">Valor Total</span>
                <span className="line-through text-[#5D5D5D]" data-id="element-149">$81.94</span>
              </div>
            </div>
          </div>

          {/* Right Side: Sales Copy & CTA */}
          <div className="p-8 md:p-12 flex flex-col justify-center relative" data-id="element-150">
            <div className="absolute top-0 right-0 bg-[#14B8A6] text-white text-xs font-bold px-4 py-2 rounded-bl-xl" data-id="element-151">
              OFERTA LIMITADA
            </div>

            <h2 className="text-3xl font-serif font-bold text-[#4A3B32] mb-2" data-id="element-152">
              Obtén Acceso Inmediato
            </h2>
            <p className="text-[#5D5D5D] mb-6" data-id="element-153">
              Empieza a desinflamarte hoy mismo. Descarga digital instantánea.
            </p>

            <div className="mb-8" data-id="element-154">
              <div className="flex items-end gap-2 mb-2" data-id="element-155">
                <span className="text-5xl font-bold text-[#14B8A6]" data-id="element-156">$9.97</span>
                <span className="text-xl text-[#5D5D5D] line-through mb-2" data-id="element-157">
                  $47
                </span>
              </div>
              <p className="text-sm text-green-600 font-medium bg-green-50 inline-block px-2 py-1 rounded" data-id="element-158">
                Ahorras 80% hoy
              </p>
            </div>

            <Button href="https://mjebook.com/cart/42951664173174:1" size="lg" fullWidth className="mb-4 shadow-xl shadow-[#14B8A6]/20 text-lg" data-id="element-159">
              DESCARGAR AHORA <ArrowRight className="ml-2" data-id="element-160" />
            </Button>

            <p className="text-xs text-center text-[#5D5D5D] mb-8" data-id="element-161">
              🔒 Pago seguro y encriptado. Acceso inmediato al correo.
            </p>

            <div className="space-y-4" data-id="element-162">
              <h4 className="font-bold text-[#4A3B32]" data-id="element-163">Incluye GRATIS:</h4>
              {bonuses.map((b, i) => <div key={i} className="flex items-start" data-id="element-164">
                  <div className="bg-[#14B8A6]/10 p-1 rounded-full mr-3 mt-0.5" data-id="element-165">
                    <Check size={14} className="text-[#14B8A6]" data-id="element-166" />
                  </div>
                  <div data-id="element-167">
                    <p className="font-bold text-[#4A3B32] text-sm" data-id="element-168">
                      {b.title}
                    </p>
                    <p className="text-xs text-[#5D5D5D]" data-id="element-169">{b.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </Section>;
}